import React, { ReactElement } from "react";
import * as Middleware from "@middlewares/index";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment-timezone";

interface IProps {
  id: number;
  type: number;
  bgImage: string;
  logo: string;
  title: string;
  description?: string;
  users: any[];
}

const StandsItem = ({
  type,
  id,
  bgImage,
  logo,
  title,
  description,
  users,
}: IProps): ReactElement => {
  const workshopData = useSelector((state: any) => state.Main.Workshop.data);
  const registerEndAt = moment(workshopData.registerEndAt)
    .tz("Europe/Moscow")
    .format();
  const now = moment().tz("Europe/Moscow").format();

  return (
    <div
      className={`stands-item stands-item--${
        type === 4
          ? "general"
          : type === 3
          ? "platinum"
          : type === 2
          ? "gold"
          : type === 1
          ? "silver"
          : type === 0
          ? "bronze"
          : ""
      }`}
      data-type="11"
    >
      {type > 1 && (
        <Link
          to={`/company/stand/${id}`}
          className="stands-item__bg"
          target="_blank"
        >
          {bgImage && (
            <picture>
              <img src={bgImage} alt={title} />
            </picture>
          )}

          {type === 3 && (
            <div className="stands-item__logo">
              <picture>
                <img src={logo} alt={`Логотип ${title}`} />
              </picture>
            </div>
          )}
        </Link>
      )}

      <div className="stands-item__content">
        {type !== 3 && (
          <Link
            to={type === 0 ? `/company/${id}` : `/company/stand/${id}`}
            className="stands-item__logo"
            target="_blank"
          >
            <div className="stands-item__logo-wrapper">
              <picture>
                <img src={logo} alt={`Логотип ${title}`} />
              </picture>
            </div>
          </Link>
        )}

        <Link
          to={type === 0 ? `/company/${id}` : `/company/stand/${id}`}
          className="stands-item__title"
          target="_blank"
        >
          {title}
        </Link>
        {(type === 4 || type === 3) && description !== null ? (
          <div className="stands-item__desc">{description}</div>
        ) : null}

        {type > 0 && (
          <div className="stands-item__footer">
            <Link
              className="btn btn--medium btn--red tariff__btn "
              to={`/company/stand/${id}`}
              target="_blank"
            >
              Изучить стенд
            </Link>
          </div>
        )}
        <a className="stands-item__bookmarks" href="#">
          &nbsp;
        </a>
      </div>
    </div>
  );
};

export default StandsItem;
